/**
 * Swym Back-in-Stock for products tagged show-notify-btn.
 * Renders into #TrooperSwymNotify-{sectionId} via swat.addToWatchList (inline).
 */
(function () {
  const productInfo = document.querySelector('product-info[data-swym-notify]');
  if (!productInfo) return;

  const sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
  const productId = productInfo.dataset.productId;
  const productPath = productInfo.dataset.url || '';
  const productUrl = `${window.shopUrl || ''}${productPath}`;
  const SOLD_OUT_LABEL = 'zur Zeit nicht lieferbar';
  const SOLD_OUT_BG = 'rgb(238, 148, 65)';
  const VARIANT_UPDATE_DELAY_MS = 150;
  const SWYM_WAIT_MS = 30000;
  const SWYM_POLL_MS = 300;

  const getSubmitButton = () => document.getElementById(`ProductSubmitButton-${sectionId}`);
  const getSubmitLabel = () => getSubmitButton()?.querySelector('span:first-child');
  const getNotifySlot = () => document.getElementById(`TrooperSwymNotify-${sectionId}`);
  const getButtonsContainer = () => productInfo.querySelector('.product-form__buttons');

  function setNotifyLayoutActive(active) {
    getButtonsContainer()?.classList.toggle('product-form__buttons--swym-notify-active', active);
  }

  function readSelectedVariant() {
    const fromPicker = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (fromPicker?.textContent?.trim()) {
      try {
        return JSON.parse(fromPicker.textContent);
      } catch {
        /* fall through */
      }
    }

    const fromScript = document.getElementById(`TrooperSwymVariant-${sectionId}`);
    if (fromScript?.textContent?.trim()) {
      try {
        return JSON.parse(fromScript.textContent);
      } catch {
        return null;
      }
    }

    return null;
  }

  function getVariantImageUrl(variant, slot) {
    const fromVariant =
      variant?.featured_image?.src ||
      variant?.featured_media?.preview_image?.src ||
      variant?.image?.src ||
      '';
    const fromSlot = slot?.dataset.productImage || '';
    const src = fromVariant || fromSlot;
    return src ? src.replace(/^https?:/, '') : '';
  }

  function buildSwymProduct(variant, slot) {
    if (!variant?.id) return null;

    const imageUrl = getVariantImageUrl(variant, slot);
    if (!imageUrl) return null;

    const separator = productUrl.includes('?') ? '&' : '?';
    return {
      epi: variant.id,
      empi: productId,
      du: `${productUrl}${separator}variant=${variant.id}`,
      pr: Number(variant.price) / 100,
      iu: imageUrl,
      et: 8,
    };
  }

  function hideNotifySlot() {
    const slot = getNotifySlot();
    if (!slot) return;
    slot.hidden = true;
    slot.innerHTML = '';
    slot.removeAttribute('data-swym-rendered');
    setNotifyLayoutActive(false);
  }

  function showSwymFormsInSlot() {
    const slot = getNotifySlot();
    if (!slot) return;
    slot.querySelectorAll('.swym-isa-inline-form').forEach((form) => {
      form.style.display = 'block';
    });
  }

  function withSwym(callback) {
    if (window._swat) {
      callback(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(callback);

    const started = Date.now();
    const waitForSwat = () => {
      if (window._swat) {
        callback(window._swat);
        return;
      }
      if (Date.now() - started < SWYM_WAIT_MS) {
        setTimeout(waitForSwat, SWYM_POLL_MS);
      }
    };
    waitForSwat();
  }

  function renderSwymWidget(variant) {
    const slot = getNotifySlot();
    const swymProduct = buildSwymProduct(variant, slot);
    if (!slot || !swymProduct || !getSubmitButton()?.disabled) return;

    slot.hidden = false;
    setNotifyLayoutActive(true);

    if (slot.dataset.swymRendered === String(variant.id)) {
      showSwymFormsInSlot();
      return;
    }

    withSwym((swat) => {
      if (!getSubmitButton()?.disabled) {
        hideNotifySlot();
        return;
      }

      slot.innerHTML = '';
      slot.hidden = false;

      try {
        // Official signature: (event, product, onSuccess, renderIntoNode, topic) — no onError
        swat.addToWatchList(null, swymProduct, () => {
          slot.dataset.swymRendered = String(variant.id);
          showSwymFormsInSlot();
        }, slot, 'backinstock');
      } catch (error) {
        console.warn('[trooper-swym-notify] addToWatchList failed', error);
      }
    });
  }

  function applySoldOutNotifyUI(variant) {
    const btn = getSubmitButton();
    const label = getSubmitLabel();
    if (!btn || !label) return;

    if (!btn.disabled) {
      btn.style.removeProperty('background');
      hideNotifySlot();
      return;
    }

    setNotifyLayoutActive(true);
    label.textContent = SOLD_OUT_LABEL;
    btn.style.setProperty('background', SOLD_OUT_BG, 'important');

    const resolvedVariant = variant || readSelectedVariant();
    if (resolvedVariant) {
      renderSwymWidget(resolvedVariant);
    }
  }

  function scheduleUpdate(variant) {
    setTimeout(() => {
      applySoldOutNotifyUI(variant || readSelectedVariant());
    }, VARIANT_UPDATE_DELAY_MS);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event?.data?.sectionId === sectionId) {
        scheduleUpdate(event.data.variant);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleUpdate());
  } else {
    scheduleUpdate();
  }
})();
